/* Piggy Proof - cart bridge + drawer enhancements
 * 1) Bridges our custom add-to-cart events to Horizon's native cart drawer.
 * 2) Enhances the native drawer (no Horizon files touched) with:
 *    - free-shipping progress bar
 *    - automatic product recommendations ("Aanbevolen producten")
 *    - light editorial styling (injected <style>)
 */
(function () {
  var THRESHOLD = 5000;   // free-shipping threshold in cents (EUR 50)
  var RECO_LIMIT = 10;
  var enhanceTimer = null;

  function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function getDrawer() { return document.querySelector('cart-drawer-component'); }
  function getDialog() { var d = getDrawer(); return d ? d.querySelector('dialog') : null; }
  function openDrawer() { var d = getDrawer(); if (d && typeof d.open === 'function') { try { d.open(); } catch (e) {} } }

  /* ---------- bridge: upgrade our pp- cart:update events to Horizon's contract ---------- */
  function cartSectionId() {
    var el = document.querySelector('cart-items-component[data-section-id]');
    return el && el.dataset.sectionId ? el.dataset.sectionId : null;
  }
  function refreshAndEmit() {
    var sid = cartSectionId();
    var jobs = [fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })];
    if (sid) {
      jobs.push(
        fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); }).catch(function () { return null; })
      );
    }
    Promise.all(jobs).then(function (res) {
      var cart = res[0] || {};
      var sj = res[1] || null;
      var sections = {};
      if (sid && sj && sj[sid] != null) sections[sid] = sj[sid];
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { __ppFixed: true, resource: cart, sourceId: 'pp-cart', data: { source: 'pp-cart', itemCount: cart.item_count, sections: sections } }
      }));
      openDrawer();
    }).catch(function () { openDrawer(); });
  }
  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail;
    if (!d || d.__ppFixed) return;
    if (typeof d.sourceId !== 'string' || d.sourceId.indexOf('pp-') !== 0) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    refreshAndEmit();
  }, true);

  /* ---------- recommendation add-to-cart (distinct attribute, no clash) ---------- */
  function recoAdd(vid, btn) {
    if (!vid || !window.fetch) return;
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { sourceId: 'pp-reco', data: {} } }));
        if (btn) btn.disabled = false;
      }).catch(function () { if (btn) btn.disabled = false; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pp-reco-add]');
    if (b) { e.preventDefault(); recoAdd(b.getAttribute('data-pp-reco-add'), b); return; }
    var oc = e.target.closest('[data-pp-open-cart]');
    if (oc) { e.preventDefault(); openDrawer(); }
  });

  /* ---------- keep our header cart count in sync ---------- */
  function syncCartCount(n) {
    document.querySelectorAll('[data-pp-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = (n === 0); });
  }
  document.addEventListener('cart:update', function (e) {
    var c = e && e.detail && e.detail.resource;
    if (c && typeof c.item_count === 'number') { syncCartCount(c.item_count); return; }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { syncCartCount(cart.item_count); }).catch(function () {});
  });

  /* ---------- styles ---------- */
  var CSS = ''
    + '.cart-drawer .pp-cd-ship{padding:12px 20px 18px;border-bottom:1px solid #e3e1db;margin-bottom:22px;}'
    + '@media(min-width:750px){.cart-drawer .pp-cd-ship{padding-left:32px;padding-right:32px;}}'
    + '.cart-drawer .pp-cd-ship-msg{font:500 13px/1.35 Inter,sans-serif;color:#161719;margin-bottom:8px;text-align:center;}'
    + '.cart-drawer .pp-cd-ship-msg b{font-weight:600;}'
    + '.cart-drawer .pp-cd-ship-track{height:8px;border-radius:999px;background:#ece9e2;overflow:hidden;}'
    + '.cart-drawer .pp-cd-ship-fill{height:100%;background:#f58320;border-radius:999px;transition:width .45s cubic-bezier(.2,.8,.2,1);}'
    + '.cart-drawer .pp-cd-reco{margin-top:20px;padding-top:18px;border-top:1px solid #e3e1db;}'
    + '.cart-drawer .pp-cd-reco-h{font:500 11px/1 "Space Mono",ui-monospace,monospace;text-transform:uppercase;letter-spacing:.09em;color:#4a4e57;margin-bottom:12px;}'
    + '.cart-drawer .pp-cd-reco-row{display:flex;gap:10px;overflow-x:auto;scrollbar-width:none;padding-bottom:4px;}'
    + '.cart-drawer .pp-cd-reco-row::-webkit-scrollbar{display:none;}'
    + '.cart-drawer .pp-cd-rc{flex:0 0 132px;border:1px solid #e3e1db;border-radius:10px;padding:8px;background:#fff;display:flex;flex-direction:column;}'
    + '.cart-drawer .pp-cd-rc-img{display:block;aspect-ratio:1/1;background:#ecebe7;border-radius:6px;overflow:hidden;}'
    + '.cart-drawer .pp-cd-rc-img img{width:100%;height:100%;object-fit:cover;}'
    + '.cart-drawer .pp-cd-rc-t{font:500 12px/1.3 Inter,sans-serif;color:#161719;margin-top:6px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:31px;}'
    + '.cart-drawer .pp-cd-rc-b{display:flex;align-items:center;justify-content:space-between;gap:6px;margin-top:8px;}'
    + '.cart-drawer .pp-cd-rc-p{font:600 13px Inter,sans-serif;color:#161719;}'
    + '.cart-drawer .pp-cd-rc-add{border:none;background:#161719 !important;color:#f7f8f0 !important;border-radius:999px;font:500 11px Inter,sans-serif;padding:7px 11px;cursor:pointer;white-space:nowrap;}'
    + '.cart-drawer .pp-cd-rc-add[disabled]{opacity:.4;cursor:not-allowed;}'
    + '.cart-drawer .pp-cd-ship-top{display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:8px;}'
    + '.cart-drawer .pp-cd-ship-msg{margin-bottom:0;}'
    + '.cart-drawer .pp-cd-ship-ico{color:#4a4e57;display:inline-flex;flex:none;}'
    + '@media(min-width:750px){.cart-drawer .cart-drawer__dialog{width:500px;max-width:95vw;}}'
    + '.cart-drawer .cart-drawer__summary{position:sticky;bottom:0;z-index:3;background:var(--color-background,#fff);}'
    + '.cart-drawer .cart-drawer__dialog[cart-summary-sticky="false"] .cart-drawer__summary{position:sticky !important;}'
    + '.cart-drawer .cart__checkout-button{background:#161719 !important;color:#f7f8f0 !important;justify-content:flex-start !important;text-align:left;padding-left:22px !important;min-height:56px;border-radius:8px;}'
    + '.cart-drawer .cart__checkout-button .button-text{color:#f7f8f0 !important;font:500 16px Inter,sans-serif;}'
    + '.cart-drawer .cart-totals__total{align-items:center;}'
    + '.cart-drawer .cart-totals__total-label{font:500 12px/1 "Space Mono",ui-monospace,monospace;text-transform:uppercase;letter-spacing:.08em;color:#161719;}'
    + '.cart-drawer .cart-totals__total-value{font:600 16px Inter,sans-serif;color:#161719;}'
    + '.cart-drawer .additional-checkout-buttons,.cart-drawer .cart__additional-checkout-buttons,.cart-drawer shopify-accelerated-checkout-cart{display:none !important;}'
    /* line items - editorial */
    + '.cart-drawer .cart-items__table-row{column-gap:14px;}'
    + '.cart-drawer .cart-items__media-container{aspect-ratio:1/1 !important;background:#ecebe7;border-radius:10px;overflow:hidden;}'
    + '.cart-drawer .cart-items__media-image{object-fit:contain !important;padding:6px;}'
    + '.cart-drawer .cart-items__title{font:600 15px/1.25 Inter,sans-serif;color:#161719;}'
    + '.cart-drawer .cart-items__details,.cart-drawer .cart-items__details *{color:#4a4e57;}'
    + '.cart-drawer .cart-items__variants-wrapper,.cart-drawer .cart-items__variants-wrapper *{color:#4a4e57;font-size:13px;}'
    + '.cart-drawer .cart-items__price{font:600 14px Inter,sans-serif;color:#161719;}'
    + '.cart-drawer .cart-items__quantity{width:100%;}'
    + '.cart-drawer .cart-items__quantity-controls{width:100%;justify-content:space-between;}'
    + '.cart-drawer .cart-items__quantity .quantity-selector{border:1px solid #e3e1db !important;border-radius:8px;}'
    + '.cart-drawer .cart-items__remove{background:none !important;box-shadow:none !important;width:auto !important;min-width:0 !important;height:auto !important;padding:0 !important;align-self:center;}'
    + '.cart-drawer .cart-items__remove svg{display:none !important;}'
    + '.cart-drawer .cart-items__remove .visually-hidden{display:none !important;}'
    + '.cart-drawer .cart-items__remove::after{content:"Verwijderen";font:500 13px Inter,sans-serif;text-decoration:underline;color:#161719;}';
  function injectStyles() {
    if (document.getElementById('pp-cd-css')) return;
    var s = document.createElement('style');
    s.id = 'pp-cd-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---------- enhancements ---------- */
  function firstAvail(p) {
    for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) return p.variants[i]; }
    return p.variants[0];
  }
  function renderShip(content, cart) {
    var holder = content.querySelector('.pp-cd-ship');
    if (!holder) { holder = document.createElement('div'); holder.className = 'pp-cd-ship'; content.insertBefore(holder, content.firstChild); }
    var total = cart.total_price || 0;
    var rem = THRESHOLD - total;
    var pct = Math.max(0, Math.min(100, total / THRESHOLD * 100));
    var msg = rem > 0
      ? ('Nog <b>' + money(rem) + '</b> tot <b>gratis verzending</b>')
      : '🎉 Je hebt <b>gratis verzending</b>!';
    var ico = '<span class="pp-cd-ship-ico"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 7h11v8H3z"/><path d="M14 10h4l3 3v2h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg></span>';
    holder.innerHTML = '<div class="pp-cd-ship-top"><div class="pp-cd-ship-msg">' + msg + '</div>' + ico + '</div><div class="pp-cd-ship-track"><div class="pp-cd-ship-fill" style="width:' + pct + '%"></div></div>';
  }
  function renderReco(content, cart) {
    var list = content.querySelector('.cart-drawer__items') || content;
    var holder = content.querySelector('.pp-cd-reco');
    if (!holder) { holder = document.createElement('div'); holder.className = 'pp-cd-reco'; list.appendChild(holder); }
    if (!cart.items || !cart.items.length) { holder.innerHTML = ''; return; }
    var pid = cart.items[0].product_id;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + RECO_LIMIT + '&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d.products || []).filter(function (p) { return !inCart[p.id] && p.variants && p.variants.length; }).slice(0, 8);
        if (!prods.length) { holder.innerHTML = ''; return; }
        var h = '<div class="pp-cd-reco-h">Aanbevolen producten</div><div class="pp-cd-reco-row">';
        prods.forEach(function (p) {
          var v = firstAvail(p);
          var src = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200') : '';
          var url = p.url || ('/products/' + p.handle);
          h += '<div class="pp-cd-rc">'
            + '<a class="pp-cd-rc-img" href="' + url + '">' + (src ? '<img src="' + src + '" alt="" loading="lazy">' : '') + '</a>'
            + '<div class="pp-cd-rc-t">' + esc(p.title) + '</div>'
            + '<div class="pp-cd-rc-b"><span class="pp-cd-rc-p">' + money(v.price) + '</span>'
            + '<button type="button" class="pp-cd-rc-add" data-pp-reco-add="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + (v.available ? 'Voeg toe' : 'Uitverkocht') + '</button></div>'
            + '</div>';
        });
        h += '</div>';
        holder.innerHTML = h;
      }).catch(function () { holder.innerHTML = ''; });
  }
  function runEnhance() {
    var dlg = getDialog();
    if (!dlg) return;
    injectStyles();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var co = dlg.querySelector('.cart__checkout-button .button-text') || dlg.querySelector('.cart__checkout-button');
        if (co) co.textContent = 'Nu afrekenen';
        var lbl = dlg.querySelector('.cart-totals__total-label');
        if (lbl) lbl.textContent = 'Subtotaal';
        var content = dlg.querySelector('.cart-drawer__content');
        if (!content) return;
        renderShip(content, cart);
        renderReco(content, cart);
      }).catch(function () {});
  }
  function scheduleEnhance() { clearTimeout(enhanceTimer); enhanceTimer = setTimeout(runEnhance, 150); }

  document.addEventListener('cart:update', function () { scheduleEnhance(); });

  function watch() {
    var dlg = getDialog();
    if (!dlg) { setTimeout(watch, 500); return; }
    if (dlg.__ppWatched) return;
    dlg.__ppWatched = true;
    new MutationObserver(function () { if (dlg.open) scheduleEnhance(); }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', watch);
})();
